var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._b({class:[
	'btn btn-'+_vm.theme, 
	_vm.icon && !_vm.$slots.default ? 'btn-icon': ''
],attrs:{"disabled":_vm.loading},on:{"click":function($event){return _vm.$emit('click', $event)}}},'button',_vm.$attrs,false),[(_vm.loading)?_c('div',{class:[
		'spinner-border spinner-border-sm',
		_vm.$slots.default ? 'mr-2' : ''
	],attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])]):(_vm.icon)?_c('i',{class:[
		'fe fe-'+_vm.icon,
		_vm.$slots.default ? 'small mr-2' : ''
	]}):_vm._e(),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }